import {
  ADD_ROOM_REQUESTED, CANCEL_BOOKING_REQUESTED, CLOSE_NAV,
  FETCH_AVAILABILITY_REQUESTED, FETCH_AVAILABILITY_RETRIED,
  FETCH_BOOKING_REQUESTED, FETCH_SERVICES_REQUESTED, FETCH_SERVICES_RETRIED,
  MAKE_BOOKING_FAILED, MAKE_BOOKING_RATE_LIMITED, MAKE_BOOKING_REQUESTED,
  MAKE_BOOKING_SUCCEEDED, SHOW_ERROR, TOGGLE_NAV, UNSET_ERROR, WINDOW_RESIZE,
} from '../actionTypes';


const initialState = {
  /* True from the moment a booking is submitted until the engine has answered.
     Lives in the ui slice on purpose: that slice is not persisted, so a reload
     mid-request cannot leave a guest locked out. The details saga refuses a
     second submit while this is set, which is what stops one route change
     mid-request from turning into two reservations. */
  bookingInProgress: false,
  error: null,
  navOpen: false,
  retryAction: null,
  windowSize: 'xxs',
};

export default function ui(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_NAV:
      return {
        ...state,
        navOpen: !state.navOpen,
      };
    case CLOSE_NAV:
      return {
        ...state,
        navOpen: false,
      };
    case WINDOW_RESIZE:
      return {
        ...state,
        windowSize: action.payload || 'xxs',
      };
    case SHOW_ERROR:
      return {
        ...state,
        retryAction: action.action,
        error: action.error,
      };
    case MAKE_BOOKING_REQUESTED:
      return {
        ...state,
        bookingInProgress: true,
        error: null,
        retryAction: null,
      };
    case MAKE_BOOKING_SUCCEEDED:
    case MAKE_BOOKING_FAILED:
    case MAKE_BOOKING_RATE_LIMITED:
      return {
        ...state,
        bookingInProgress: false,
      };
    case FETCH_AVAILABILITY_REQUESTED:
    case FETCH_AVAILABILITY_RETRIED:
    case FETCH_SERVICES_REQUESTED:
    case FETCH_SERVICES_RETRIED:
    case ADD_ROOM_REQUESTED:
    case FETCH_BOOKING_REQUESTED:
    case CANCEL_BOOKING_REQUESTED:
    case UNSET_ERROR:
      return {
        ...state,
        error: null,
        retryAction: null,
      };
    default:
      return state;
  }
}

export const getError = (state) => state.error;
export const isBookingInProgress = (state) => !!state.bookingInProgress;
export const getNavOpen = (state) => state.navOpen;
export const getRetryAction = (state) => state.retryAction;
export const getWindowSize = (state) => state.windowSize;
